// extracted by mini-css-extract-plugin
export default {"container":"Discord_container__ZLbEU","title":"Discord_title__kWK22","sub":"Discord_sub__WJfQ1","btn":"Discord_btn__lctja"};